import PropTypes from 'prop-types'
import MaskedFiel from './MaskedField'

class CodePostalField extends MaskedFiel {
    constructor(props){
        super(props);
        this.state = {...this.state, mask:[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]};
    }
}

CodePostalField.propTypes= {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
}

export default CodePostalField


// WEBPACK FOOTER //
// ./src/components/custom/CodePostalField.js